const DOMAIN = 'lending.services.public.onboarding.lzOnboarding.backgroundProvider.';

const BACKGROUND_DESCRIPTION = `${DOMAIN}description`;

export { BACKGROUND_DESCRIPTION };
